/**
 * @Description: 耗材附加属性值信息相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  MaterialAttributeValueModel,
  MaterialAttributeValueSearchModel,
  MaterialAttributeValuePageSearchModel,
  MaterialAttributeValueAddModel,
  MaterialAttributeValueUpdateModel,
  IdsModel
} from '@/model/product/MaterialAttributeValueModel'

const baseUrl = Route.product + '/materialAttributeValue'

/**
 * 搜索分页数据
 */
export const pageSearchMaterialAttributeValue = (param: MaterialAttributeValuePageSearchModel) => {
  return https().request<RootObject<PageRespModel<MaterialAttributeValueModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchMaterialAttributeValue = (param: MaterialAttributeValueSearchModel) => {
  return https().request<RootObject<MaterialAttributeValueModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getMaterialAttributeValue = (id: number) => {
  return https().request<RootObject<MaterialAttributeValueModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addMaterialAttributeValue = (param: MaterialAttributeValueAddModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据
 */
export const updateMaterialAttributeValue = (param: MaterialAttributeValueUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removeMaterialAttributeValue = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemoveMaterialAttributeValue = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
